import React from 'react'
import { useTranslation } from 'react-i18next'
import { Message } from 'semantic-ui-react'
import Dialog from '~/components/Dialog'
import { formatNumber } from '~/utils/helpers'

interface Props {
  energyCalcData: any
  isEnergyModalOpen: boolean
  handleClose: () => void
  heiferEnergyModal?: boolean
}

const EnergyModal: React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const {
    energyCalcData,
    isEnergyModalOpen,
    handleClose,
    heiferEnergyModal
  } = props

  function getCowMessage() {
    const totalEnergyWithAddition = `${formatNumber(energyCalcData?.totalEnergyWithAddition, 0)} MJ NEL/Jahr`
    if (energyCalcData?.energyAddition < 0) {
      return <Message error>
        <p>
          {`Aus der von Ihnen eingegebenen Futterration errechnet sich ein Futterenergiegehalt von ${totalEnergyWithAddition} MJ NEL/Jahr. 
         Der Futterenergiegehalt liegt bei Ihrem Betrieb unter dem Gesamtenergiebedarf je Kuh. Bitte kontrollieren Sie Ihre eingegebene Futterration nochmal auf Plausibilität und passen Sie diese an.`}
        </p>
      </Message>

    } else if (energyCalcData?.energyAddition >= 100) {
      return <Message error>
        <p>
          {`Aus der von Ihnen eingegebenen Futterration errechnet sich ein Futterenergiegehalt von ${totalEnergyWithAddition} MJ NEL/Jahr. 
          Der Futterenergiegehalt liegt bei Ihrem Betrieb deutlich über dem Gesamtenergiebedarf je Kuh. Bitte kontrollieren Sie Ihre eingegebene Futterration nochmal auf Plausibilität und passen Sie diese an.`}
        </p>
      </Message>
    }
    else if (energyCalcData?.energyAddition > 30) {
      return <Message warning>
        <p>
          {`Aus der von Ihnen eingegebenen Futterration errechnet sich ein Futterenergiegehalt von ${totalEnergyWithAddition} MJ NEL/Jahr. Der Futterenergiegehalt liegt bei Ihrem Betrieb über dem Gesamtenergiebedarf je Kuh. 
         Bitte kontrollieren Sie nochmal Ihre eingegebene Futterration auf Plausibilität und passen diese gegebenenfalls an. Sie könnten dennoch mit der THG-Emissionsberechnung fortfahren.`}
        </p>
      </Message>
    }
  }

  function getHeiferMessage() {
    return <Message success>
      <p>
        <div>{'Bitte überprüfen Sie die Angaben in der Tabelle.'}</div>
        <div>{'Sofern Sie „angelehnt an DLG-Fütterungsempfehlung“ ausgewählt haben,'}</div>
        <div>{'sind feste Werte vorgegeben, die nicht änderbar sind.'}</div>
      </p>
    </Message>
  }

  return <Dialog
    open={isEnergyModalOpen && energyCalcData}
    handleClose={() => handleClose()}
    contentAutoSize={heiferEnergyModal}
    textHeader={heiferEnergyModal ? '' : t('Feed energy requirements')}
    textClose={t('Close the window')}
    textContent={<div style={{ textAlign: 'center' }}>
      {heiferEnergyModal ? getHeiferMessage() : getCowMessage()}
    </div>
    }
  />
}
export default EnergyModal